var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewfinderTaxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F8541ED4-764D-4CA5-95C7-5B40320227B1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-investment-attributes",
    transform: "translate(-1041.000000, -259.000000)",
    fill: "#AD6A99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(135.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes",
    transform: "translate(145.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taxes",
    transform: "translate(672.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(19.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/taxes",
    transform: "translate(65.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5172416,4.00000016 L21.5517249,4.00000016 L21.5517249,8.1018292 C27.6753118,8.90916376 32.4137938,14.390526 32.4137938,20 C20.0000004,20 18.8714737,20 7.58620699,20 C7.58620699,14.3905258 12.3246893,8.9091634 18.4482765,8.10182912 L18.4482765,4.00000016 L19.4827588,4.00000016 L19.4827588,0 L20.5172416,0 L20.5172416,4.00000016 Z M8.10344835,25 L11.2068967,25 L11.2068967,35.9999998 L8.10344835,35.9999998 L8.10344835,25 Z M13.2758617,25 L16.3793101,25 L16.3793101,35.9999998 L13.2758617,35.9999998 L13.2758617,25 Z M18.4482765,25 L21.5517249,25 L21.5517249,35.9999998 L18.4482765,35.9999998 L18.4482765,25 Z M23.6206897,25 L26.7241381,25 L26.7241381,35.9999998 L23.6206897,35.9999998 L23.6206897,25 Z M28.7931029,25 L31.8965513,25 L31.8965513,35.9999998 L28.7931029,35.9999998 L28.7931029,25 Z M5.9,37.0000013 L34.1,37.0000013 C34.5970563,37.0000013 35,37.402945 35,37.9000013 L35,39.1000012 C35,39.5970575 34.5970563,40.0000012 34.1,40.0000012 L5.9,40.0000012 C5.40294373,40.0000012 5,39.5970575 5,39.1000012 L5,37.9000013 C5,37.402945 5.40294373,37.0000013 5.9,37.0000013 Z M5.9,21.0000006 L34.1,21.0000006 C34.5970563,21.0000006 35,21.4029444 35,21.9000006 L35,23.1000006 C35,23.5970568 34.5970563,24.0000006 34.1,24.0000006 L5.9,24.0000006 C5.40294373,24.0000006 5,23.5970568 5,23.1000006 L5,21.9000006 C5,21.4029444 5.40294373,21.0000006 5.9,21.0000006 Z",
    id: "ic/taxes"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewfinderTaxes);
export default __webpack_public_path__ + "static/media/viewfinder_taxes.ee79651f5c310187d7eb96c6d04558a9.svg";
export { ForwardRef as ReactComponent };